
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="py-12 px-4 border-t border-slate-900">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-tr from-indigo-600 to-blue-400 rounded-lg flex items-center justify-center font-bold text-white">Q</div>
            <span className="text-xl font-bold tracking-tight">Qualle</span>
        </div>
        
        <div className="flex gap-8 text-slate-500 text-sm">
          <a href="#" className="hover:text-white transition-colors">Política de Privacidade</a>
          <a href="#" className="hover:text-white transition-colors">Termos de Uso</a>
          <a href="#" className="hover:text-white transition-colors">Contato</a>
        </div>

        <div className="text-slate-500 text-sm">
          © {new Date().getFullYear()} Qualle. Todos os direitos reservados.
        </div>
      </div>
    </footer>
  );
};
